import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import type { Observable } from 'rxjs';
import { EMPTY } from 'rxjs';
import { CookiesCSR } from './cookies.csr';
import type { CookiesKeys } from './cookies.keys';
import { CookiesSSR, provideCookiesSSRContainer } from './cookies.ssr';

export abstract class CookiesService {
  public didUpdated(): Observable<void> {
    return EMPTY;
  }

  public async get(_key: CookiesKeys): Promise<string | undefined> {
    return undefined;
  }

  public async set(
    _name: CookiesKeys,
    _value: string,
    _expires?: Date,
    _path?: string,
    _domain?: string
    // eslint-disable-next-line @typescript-eslint/no-empty-function
  ): Promise<void> {}

  public getThemeState(): Observable<string | undefined> {
    return EMPTY;
  }
}
export function provideCookiesService(): CookiesService {
  if (__RENDER_MODE__ === 'server') {
    return provideSingleton(CookiesService, () => new CookiesSSR(provideCookiesSSRContainer()));
  }
  return provideSingleton(CookiesService, () => new CookiesCSR());
}
